<div class="main-layout">
  <app-header></app-header>
  <main class="main-content">
    <div class="content tds-u-flex tds-u-flex-dir-col tds-background-white">
      <app-toast></app-toast>
      <app-spinner></app-spinner>
      <router-outlet></router-outlet>
    </div>
  </main>
  <app-footer></app-footer>
</div> 